
  import Sortable from "sortablejs";

  export default {
    mounted() {
      this.ensureSortable();
    },
    updated() {
      this.ensureSortable();
      this.settle();
    },
    destroyed() {
      if (this.sortable) {
        this.sortable.destroy();
        this.sortable = null;
      }
      clearTimeout(this.settleTimeout);
    },
    ensureSortable() {
      const disabled = this.el.dataset.reorderDisabled === "true";

      if (this.sortable) {
        this.sortable.option("disabled", disabled);
        return;
      }

      this.sortable = Sortable.create(this.el, {
        animation: 150,
        handle: "[data-reorder-handle]",
        ghostClass: "opacity-0",
        dragClass: "bg-annotation-vaccination!",
        disabled: disabled,
        onStart: () => {
          this.suppressHoverStates();
        },
        onEnd: () => {
          this.restoreHoverStates();
          this.el.classList.add("reordering");
          // Failsafe: a drop that didn't actually change the order produces an
          // identical render, so no patch (and therefore no `updated()` call) will
          // ever arrive to clear the class.
          clearTimeout(this.settleTimeout);
          this.settleTimeout = setTimeout(() => this.settle(), 500);
          this.pushOrder();
        },
      });
    },
    settle() {
      clearTimeout(this.settleTimeout);
      this.el.classList.remove("reordering");
    },
    suppressHoverStates() {
      // The dragged card physically passes over its siblings' hover zones, which
      // would otherwise light them up (background/border) and pop their grip/move
      // tooltips as if inviting a click -- misleading mid-drag. Strip every
      // hover:*/group-hover:* class for the drag's duration and restore it on drop,
      // rather than fighting this in CSS (no cascade layers here, so nothing short
      // of hardcoding every resting color could reliably beat :hover, and disabling
      // pointer-events would also blind Sortable's own drop-target hit-testing).
      this.suppressedHoverClasses = [];
      this.el.querySelectorAll('[class*="hover:"]').forEach((el) => {
        const classes = Array.from(el.classList).filter((c) => c.includes("hover:"));
        el.classList.remove(...classes);
        this.suppressedHoverClasses.push({ el, classes });
      });
    },
    restoreHoverStates() {
      (this.suppressedHoverClasses || []).forEach(({ el, classes }) => el.classList.add(...classes));
      this.suppressedHoverClasses = [];
    },
    pushOrder() {
      const order = Array.from(this.el.querySelectorAll("[data-page-index]")).map((el) =>
        parseInt(el.dataset.pageIndex, 10)
      );
      const extra = JSON.parse(this.el.dataset.reorderPayload || "{}");

      this.pushEventTo(this.el, this.el.dataset.reorderEvent, { ...extra, order });
    },
  };
